import {getField, updateField} from 'vuex-map-fields';
import LibraryDocModule from '@/commonFunction/consumerModule'

let current_module = new LibraryDocModule('/ws/library/doc/');

const state = {
    ...current_module.state,
    columns: [
        {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: '', value: 'name', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'UUID', value: 'uid', sortable: true, filterable: true, divider: true,},
        {text: 'Topic', value: 'library_topic_name', sortable: true, filterable: true, divider: true,},

        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true,},
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true,},
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime',},
    ],
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['id'],
        sortDesc: [true],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        LibraryDocTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}